export default "__VITE_ASSET__D98c58Nu__"